import React from 'react';
interface Props {
  fillColor?: string;
}
function OrthoticsIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none">
      <g clipPath="url(#clip0_851_3495)">
        <path
          d="M10.1156 2.35078C11.0969 2.10391 12.1969 1.89453 13 1.89453C14.2875 1.89453 15.8062 2.22578 16.9531 2.79766C18.1875 3.41641 18.5 4.02891 18.5 4.39453C18.5 4.68828 18.3406 5.06641 17.3781 5.42891C16.4594 5.77578 15.2844 5.89453 14.5 5.89453C13.4156 5.89453 12.8281 5.56953 11.9937 5.09141L11.9719 5.07891C11.3281 4.71016 10.5625 4.27266 9.5 4.04766V2.51328C9.6875 2.46016 9.89688 2.40703 10.1156 2.35078ZM8 5.39453C9.5 5.39453 10.375 5.89453 11.25 6.39453C12.125 6.89453 13 7.39453 14.5 7.39453C16.2625 7.39453 20 6.89453 20 4.39453C20 1.89453 16 0.394531 13 0.394531C11.0094 0.394531 8 1.39453 8 1.39453V3.89453V5.39453ZM4 3.39453C4 4.49766 4.89687 5.39453 6 5.39453H7V1.39453H6C4.89687 1.39453 4 2.29141 4 3.39453ZM6.11562 14.4383C5.89687 14.382 5.6875 14.3289 5.5 14.2758V12.7414C6.5625 12.5133 7.32812 12.0758 7.97188 11.7102L7.99375 11.6977C8.82812 11.2195 9.41562 10.8945 10.5 10.8945C11.2875 10.8945 12.4594 11.0102 13.3781 11.3602C14.3406 11.7227 14.5 12.1008 14.5 12.3945C14.5 12.7602 14.1875 13.3727 12.9531 13.9914C11.8062 14.5633 10.2875 14.8945 9 14.8945C8.19687 14.8945 7.09687 14.6852 6.11562 14.4383ZM4 11.3945V12.8945V15.3945C4 15.3945 7.00938 16.3945 9 16.3945C12 16.3945 16 14.8945 16 12.3945C16 9.89453 12.2625 9.39453 10.5 9.39453C9 9.39453 8.125 9.89453 7.25 10.3945C6.375 10.8945 5.5 11.3945 4 11.3945ZM0 13.3945C0 14.4977 0.896875 15.3945 2 15.3945H3V11.3945H2C0.896875 11.3945 0 12.2914 0 13.3945Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3495">
          <rect
            width="20"
            height="16"
            fill="white"
            transform="translate(0 0.394531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OrthoticsIcon;
